export default __webpack_public_path__ + "source-sans-pro-v11-latin-italic-6b1f4ebf0a952c64fc09328418b4f71b.bundle.woff2";